<div class="album-manager">
  <mat-spinner 
    *ngIf="!ready" 
    diameter="40"
  />

  <!-- Tabella -->
  <div *ngIf="albums.length > 0; else addFirstAlbum">
    <h2>ALBUMS</h2>
    <table class="album-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Album</th>
          <th>Title</th>
          <th>Author</th>
          <th>Label</th>
          <th>Year</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let album of albums; let i = index">
          <td class="order">
            <span class="num">
              {{ i + 1 }}
            </span>
            <input type="checkbox" name="on">
          </td>
          <td 
            class="img" 
            title="{{ album.imgUrl }}"
          >
            <img src="{{album.imgUrl}}" alt="{{album.title}}">
          </td>
          <td>{{ album.title }}</td>
          <td>{{ album.author }}</td>
          <td>{{ album.label }}</td>
          <td>{{ album.year }}</td>
          <td>{{ album.description }}</td>
          <td class="action-buttons">
            <button (click)="editRecord(i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button (click)="removeRecord(i)">
              <mat-icon>delete</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'up')" [disabled]="i === 0">
              <mat-icon>arrow_upward_alt</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'down')" [disabled]="i === albums.length - 1">
              <mat-icon>arrow_downward_alt</mat-icon>
            </button>
            <button (click)="addRecord(i)">
              <mat-icon>add</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #addFirstAlbum>
    <div
      class="add-first-album"
      (click)="addRecord(-1)"
    >
      ADD AN ALBUM
    </div>
  </ng-template>
  
</div>